import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_MARKET_INDEX_LIST_API_ID =
  'DASHBOARD/FETCH_MARKET_INDEX_LIST_API_ID';

const apiCall = createApiCall(
  FETCH_MARKET_INDEX_LIST_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/market-indexes`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
